import { render } from "./ModalAdicionarMarca.vue?vue&type=template&id=5cfff454&scoped=true&ts=true"
import script from "./ModalAdicionarMarca.vue?vue&type=script&lang=ts"
export * from "./ModalAdicionarMarca.vue?vue&type=script&lang=ts"

import "./ModalAdicionarMarca.vue?vue&type=style&index=0&id=5cfff454&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfff454"]])

export default __exports__